<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-usb`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.977 6.267c-.326-.174-.65-.267-1.54-.267H14.563c-.892 0-1.215.093-1.54.267a1.81 1.81 0 00-.757.756c-.174.326-.267.65-.267 1.54V21h-.872c-1.783 0-2.43.186-3.082.534a3.635 3.635 0 00-1.512 1.512C6.186 23.698 6 24.345 6 26.128v15.744c0 .44.011.811.034 1.13L10 43V25h28v18l3.966.002c.023-.319.034-.69.034-1.13V26.128c0-1.783-.186-2.43-.534-3.082a3.635 3.635 0 00-1.512-1.512c-.652-.348-1.299-.534-3.082-.534H36V8.564c0-.892-.093-1.215-.267-1.54a1.817 1.817 0 00-.756-.757zM16 10h16v11H16V10zm6 3v4h-4v-4h4zm8 4v-4h-4v4h4z"/></svg>
</template>
<script>

export default {
  name: 'IconUsb',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
